import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import './CreditCardPlusModule.scss';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import StandardCreditCardPlus from 'components/Offers/StandardCreditCardPlus/StandardCreditCardPlus';
import OfferCarouselContainer from 'partial/OfferManager/OfferCarouselContainer';
import { Row } from 'components/Containers/Row/Row';
import SeeAll from 'components/SeeAllButton/index';
import { SESAME_PLUS_CARDS_OFFERS } from 'types/morph.pagePosition.constants';
import NotQualifiedPlusCard from 'components/Offers/StandardCreditCardPlus/NotQualifiedPlusCard';
import GoToCCMarketplaceButton from 'components/GoToCCMarketplaceButton';

const ViewOffers = props => {
  const {
    eventHandler,
    notQualify,
    isCreditBuilder,
    offers,
    onClickActionItems,
  } = props;

  if (notQualify) {
    return <NotQualifiedPlusCard onClickActionItems={onClickActionItems} />;
  } else {
    return (
      <FlexContainer>
        <FlexContainer className={'flex-column m-hide width100 height100'}>
          <Row type="carousel" className={'padLR0 height100'}>
            <OfferCarouselContainer
              offers={offers}
              type={'creditCardRedesignCarousel'}
              creditCardTemplate={StandardCreditCardPlus}
              templateCustomClass={'dashboardCreditCardPlus'}
              pagePosition={SESAME_PLUS_CARDS_OFFERS}
              eventHandler={eventHandler}
              datatestid={`carousel-creditcardplus-desktop`}
              extraAttributes={{ isCreditBuilder }}
            />
          </Row>
        </FlexContainer>
        <FlexContainer className={'d-hide flex-column width100'}>
          <StaticOfferContainer
            offerMetadataList={offers}
            creditCardTemplate={StandardCreditCardPlus}
            pagePosition={SESAME_PLUS_CARDS_OFFERS}
            eventHandler={eventHandler}
            datatestid={`creditcardplus-mobile`}
            extraAttributes={{ isCreditBuilder }}
          />
        </FlexContainer>
      </FlexContainer>
    );
  }
};

const CreditCardPlusModuleView = props => {
  const {
    offers,
    eventHandler,
    notQualify,
    isCreditBuilder,
    seenModule,
    onClickLearnHowToImprove,
    onClickSeeMore,
    onClickActionItems,
  } = props;

  return (
    <FlexContainer className={'creditCardPlus flex-column'}>
      {seenModule}
      <FlexContainer className={'flex-column gap-6 margB20'}>
        <FlexContainer
          className={'justify-between align-items-center align-baseline'}
        >
          <Label
            type="H2"
            typeHeader={'h2'}
            className={'labelSesamePick margB0'}
          >
            Sesame+ Pick credit card offers
          </Label>
          <SeeAll
            onClick={onClickSeeMore}
            labelText={'SEE MORE'}
            className={
              'm-hide text-12 m-text-12 align-baseline secondary_text_light'
            }
          />
        </FlexContainer>
        <Label className={'labelChoose'}>
          {' '}
          Choose from offers with the top approval odds.
        </Label>
        <Label
          className={'labelChoose blueB100 pointer'}
          onClick={onClickLearnHowToImprove}
        >
          Learn how to improve your grade
        </Label>
      </FlexContainer>
      <FlexContainer
        className={'justify-between margB16 align-items-center align-baseline'}
      >
        <Label type={'Subtitle-1'}>Credit Cards</Label>
        <SeeAll
          onClick={onClickSeeMore}
          className={
            'd-hide text-12 m-text-12 align-baseline secondary_text_light'
          }
          labelText={'SEE MORE'}
        />
      </FlexContainer>
      <ViewOffers
        eventHandler={eventHandler}
        offers={offers?.slice(0, 3)}
        notQualify={notQualify}
        isCreditBuilder={isCreditBuilder}
        onClickActionItems={onClickActionItems}
      />

      <GoToCCMarketplaceButton onClickHandler={onClickSeeMore} />
    </FlexContainer>
  );
};
export default CreditCardPlusModuleView;
